import React from 'react'
import { CopyIcon } from 'uiComponents/buttons/copyIcon'
import classNames from 'classnames'
import './infoRow.scss'

interface InfoRowContainerProps {
    children: React.ReactNode
    className?: string
    loading?: boolean
}

export const InfoRowContainer = ({ className, children, loading }: InfoRowContainerProps) => (
    <div className={classNames('info-row-container', className, { loading })}>{children}</div>
)

interface InfoRowProps {
    label: string
    value?: string | React.ReactNode
    placeholder?: string
    copyable?: boolean
    className?: string
    loading?: boolean
}

export const InfoRow = ({ label, value, placeholder = '-', copyable = false, className, loading }: InfoRowProps) => (
    <div className={classNames('info-row', className, { loading })}>
        <span className="label">{label}</span>
        <span className="value">
            {value || placeholder}
            {copyable && typeof value === 'string' && <CopyIcon text={value} />}
        </span>
        <span className="skeleton-wrapper">
            <div className="skeleton" />
        </span>
    </div>
)
